import React from 'react';
import { Card } from 'nelitomorphism';
import './About.css';

const About = () => {
  return (
    <section id="about">
      <Card title="About">
        <div className="about-text">
          <p className="about-intro">
            I'm Nelito Junior, full-stack engineer at{' '}
            <a href="https://fuel.network" target="_blank" rel="noopener noreferrer">
              Fuel Network
            </a>
            . I build the chain explorer, the indexer and the extension wallet for
            the Fuel blockchain. These tools handle real funds, so correctness comes
            before everything else.
          </p>
          <p>
            Before web3 I spent a decade on product teams. At Mind the Graph I moved
            a PHP/jQuery codebase to React and Node while the product stayed live. At
            Duda I built internal tools through the Snipcart acquisition. At Bulldesk
            I wrote Laravel and Vue with tests first.
          </p>
          <p>
            My last three companies were based in three different countries, so
            remote and async is my default mode. Portuguese native, English fluent.
            My UTC-3 working day overlaps every US timezone.
          </p>
        </div>
      </Card>
    </section>
  );
};

export default About;
